import { EventIdentifier } from '@capsicum/common';
import { useStakeAllFanTokensAnalytics } from '@capsicum/socios-core';

export const useStakeAllFanTokensCTAEvent = () => {
	const { sendStakeAllFanTokensEvent: sendStakeAllFanTokensCTAEvent } = useStakeAllFanTokensAnalytics({
		eventIdentifier: EventIdentifier.TriggerClickStakeall
	});

	return {
		sendStakeAllFanTokensCTAEvent
	};
};
